import { helper } from '@ember/component/helper';

/**
 * Concatena parametri in una stringa separata da spazi
 */
function concatString(params) {
  if (!Array.isArray(params) || params.length === 0) return '';
  return params.filter(Boolean).join(' ');
}
var concatString$1 = helper(concatString);

export { concatString, concatString$1 as default };
//# sourceMappingURL=concat-string.js.map
